import React, { ReactNode, FC } from "react";

interface ListPriceProps {
  children: ReactNode;
}

export const ListPrice: FC<ListPriceProps> = ({ children }) => {
  return (
    <h6 className="m-0 fw-normal" style={{color:'#1AD598',fontSize:'14px'}}>
      
      <span>
        <svg
          width="10"
          height="10"
          viewBox="0 0 24 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.76288 0C5.99999 3.33814e-05 6.96907 0.515397 7.67011 1.54609C8.41237 2.53563 8.82474 3.89619 8.90722 5.62778V12.1214H10.6392L13.5464 15.0899H8.90722V23.5006C8.90721 24.1603 9.15463 24.7581 9.64948 25.2941C10.1443 25.8301 10.9484 26.0981 12.0619 26.0981C13.5051 26.0981 15.0309 25.2941 16.6392 23.6862C18.2886 22.037 19.1546 20.3466 19.2371 18.615L18.4948 18.6768C15.8557 18.6768 14.5361 17.275 14.5361 14.4714C14.5361 13.5232 14.8453 12.678 15.4639 11.9358C16.0825 11.1937 17.1134 10.8227 18.5567 10.8227C20.0825 10.8227 21.3608 11.4824 22.3918 12.8017C23.4639 14.121 24 15.729 24 17.6255C24 20.4291 22.8041 23.109 20.4124 25.6652C18.0618 28.2214 15.2577 29.4995 12 29.4995C10.8041 29.4995 9.52576 28.9841 8.16495 27.9534C6.84535 26.8814 6.06185 25.8507 5.81443 24.8612V15.0899H2.84536L0 12.1214H5.81443V6.24622C5.81443 5.0506 5.09278 4.34971 3.64948 4.14353C2.98969 4.14356 2.5567 4.24664 2.35052 4.45275C1.97938 3.83435 1.62887 3.09222 1.29897 2.22638V1.91716C1.29897 1.38121 1.86654 0.945528 2.47024 0.556597C3.22377 0.0711351 4.10309 3.33814e-05 4.76288 0Z"
            fill="#1AD598"
          />
        </svg>
      </span>{" "}{children}
    </h6>
  );
};
